export default __webpack_public_path__ + "static/media/nico-uchitel-2@2x.549a082d.png";